/* unplugin-vue-components disabled */import { render } from "./average-statistics.vue?vue&type=template&id=dddeb876"
import script from "./average-statistics.vue?vue&type=script&lang=js"
export * from "./average-statistics.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/amoeba-logistics-information-system-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__